export default function routeParent(current_route: string, new_route: string) {
	const route_name_parts = current_route.split(':');
	route_name_parts[route_name_parts.length - 1] = new_route;
	return route_name_parts.join(':');
}
